
import { mapState } from 'vuex';
import businessFormMixin from '~/mixins/businessForm';
import fileUploadService from '~/services/fileUpload';
import loginUserMixin from '~/mixins/loginUser';
import registerUserMixin from '~/mixins/registerUser';
import persistCoverageAreaMixin from '~/mixins/persistCoverageArea';

export default {
    name: 'BusinessRegister',
    mixins: [businessFormMixin, loginUserMixin, registerUserMixin, persistCoverageAreaMixin],
    async asyncData({ app }) {
        const autoQuotes = await app.$axios.$get(app.$config.endpoints.autoBidDefaults);
        return {
            autoQuotes: autoQuotes?.defaults,
            auto_quote_grab_bag_message: autoQuotes?.defaults?.find((autoQuote) => autoQuote.service_id === 3)?.message,
            auto_quote_skip_message: autoQuotes?.defaults?.find((autoQuote) => autoQuote.service_id === 2)?.message,
        };
    },
    data() {
        return {
            autoQuotes: [],
        };
    },
    computed: mapState(['auth']),
    created() {
        this.showUserStep = !this.auth.loggedIn;
        if (this.showUserStep) {
            this.$form.addValidations({
                ...this.getUserLoginValidations(),
                ...this.getUserValidations(),
            });
        }
    },
    mounted() {
        if (this.auth?.user?.organisation) {
            this.$router.replace({ name: 'dashboard' });
        }
    },
    methods: {
        persistLogo() {
            return new Promise((resolve) => {
                if (!this.logo.length) {
                    resolve();
                } else {
                    fileUploadService(this.logo, this.$axios, this.$config, this.$sentry).then((images) => {
                        resolve(images.map((image) => image.id)[0]);
                    });
                }
            });
        },
        async registerBusiness() {
            this.$form.$submitted = true;
            if (this.$form.validate()) {
                const logo = await this.persistLogo();
                const { organisation } = await this.$form.submit(this.$config.endpoints.organisation, '$post', {
                    address_1: this.addressLine1,
                    agency: this.agency,
                    auto_bid: this.buildAutoQuoteArray(),
                    name: this.business_name,
                    categories: this.categories,
                    contact_number: this.contact_number,
                    ...(this.contact_number_2 && { contact_number_2: this.contact_number_2 }),
                    nationwide: this.nationwide,
                    postcode: this.postcode,
                    public_address: this.displayAddressPublically,
                    lat: this.lat,
                    lon: this.lon,
                    services: this.services,
                    vat: this.vat,
                    ...(this.addressLine2 && { address_2: this.addressLine2 }),
                    ...(this.description && { description: this.description }),
                    ...(logo && { image_id: logo }),
                    ...(this.reg_no && { registration_number: this.reg_no }),
                    ...(this.url && { url: this.url }),
                });
                await this.persistCoverageAreas(organisation);
                this.$auth.fetchUser();
                this.$router.push({ name: 'dashboard' });
            }
        },
    },
};
